import React from 'react';
import Icon from '../../../components/AppIcon';

const SalesMetricsPanel = ({ metrics }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-professional">
      <h3 className="text-lg font-semibold text-foreground mb-4">Sales Overview</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {metrics?.map((metric, index) => (
          <div key={index} className="bg-muted/30 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${metric?.bgColor}`}>
                <Icon name={metric?.icon} size={16} color="white" />
              </div>
              <div className={`flex items-center text-xs ${metric?.trend === 'up' ? 'text-success' : metric?.trend === 'down' ? 'text-error' : 'text-muted-foreground'}`}>
                {metric?.trend === 'up' && <Icon name="TrendingUp" size={12} />}
                {metric?.trend === 'down' && <Icon name="TrendingDown" size={12} />}
                <span className="ml-1">{metric?.change}</span>
              </div>
            </div>
            <div className="space-y-1">
              <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
              <p className="text-sm text-muted-foreground">{metric?.label}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalesMetricsPanel;